import React, { useRef } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product, vial, index }) => {
  const cardRef = useRef(null);
  const { addItem, setOpen } = useCart();

  const onMove = (e) => {
    const el = cardRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - rect.left}px`);
    el.style.setProperty("--my", `${e.clientY - rect.top}px`);
  };

  const testId = product.id;

  const handleAdd = () => {
    addItem(product, vial);
    toast.success(`${product.name} added to cart`, {
      action: { label: "View cart", onClick: () => setOpen(true) },
    });
  };

  return (
    <motion.div
      ref={cardRef}
      onMouseMove={onMove}
      data-testid={`product-card-${testId}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="spotlight-card group relative flex flex-col bg-[#0D0D0D] border border-[#1c1c1c] hover:border-[#3a382f] transition-colors duration-500"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-gradient-to-b from-[#141414] to-[#080808]">
        <img
          src={vial}
          alt={product.name}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-contain object-center p-6 transition-transform duration-700 group-hover:scale-[1.06]"
        />
        <div className="absolute left-1/2 top-[54%] -translate-x-1/2 -translate-y-1/2 w-[58%] bg-[#E6DFD4] text-black text-center py-2 px-2 shadow-[0_8px_30px_rgba(0,0,0,0.6)]">
          <div className="font-display text-lg md:text-xl leading-none tracking-wide uppercase">{product.name}</div>
          <div className="text-[8px] tracking-[0.3em] uppercase font-bold text-black/60 mt-1">SANDFORM</div>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-6">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-display text-2xl leading-none tracking-wide uppercase text-[#F5F5F5]">{product.name}</h3>
          <div className="text-right shrink-0">
            <div className="font-display text-2xl leading-none text-[#E6DFD4]">{product.price}</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#737373]">AED</div>
          </div>
        </div>

        <p className="mt-3 text-sm text-[#A3A3A3] leading-relaxed flex-1">{product.desc}</p>

        <button
          data-testid={`add-to-cart-${testId}`}
          onClick={handleAdd}
          className="mt-6 inline-flex items-center justify-center gap-2.5 border border-[#2c2c2c] bg-transparent hover:bg-[#E6DFD4] hover:text-black hover:border-[#E6DFD4] text-[#E6DFD4] px-5 py-3.5 text-[11px] tracking-[0.2em] uppercase font-bold transition-colors duration-300"
        >
          <Plus size={15} />
          Add to Cart
        </button>
      </div>
    </motion.div>
  );
};

export default ProductCard;
